import { Icon } from "@atoms";
import { pxToRem } from "@utils";
import { useTranslation } from "react-i18next";

export const BookingFailedLabel = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <p className="text-functional-red">{t("timeslots:WorkspaceBookingMandatoryOffense")}</p>

      <div className="flex items-center justify-center size-[17px] bg-functional-red rounded-full text-white">
        <Icon
          icon="warning"
          size={pxToRem(12)}
          color="currentColor"
        />
      </div>
    </div>
  );
};
